import { Routes } from '@angular/router';
import { AppLayout } from './app/layout/component/app.layout';
import { Dashboard } from './app/pages/dashboard/dashboard';
import { Documentation } from './app/pages/documentation/documentation';
import { Landing } from './app/pages/landing/landing';
import { Notfound } from './app/pages/notfound/notfound';
import { miniModeGuard } from './app/core/guards/mini-mode.guard';
import { authGuard } from './app/core/auth/auth.guard';

export const appRoutes: Routes = [
    { path: 'auth', loadChildren: () => import('./app/pages/auth/auth.routes') },
    {
        path: '',
        component: AppLayout,
        canActivate: [authGuard, miniModeGuard],
        children: [
          { path: '', loadChildren: () => import('./app/features/dashboard/dashboard.routes')},
          { path: 'portal', loadChildren: () => import('./app/features/portal/portal.routes') },
          { path: 'company', loadChildren: () => import('./app/features/company/company.routes') },
          { path: 'banks', loadChildren: () => import('./app/features/bank/bank.routes') },
          { path: 'credit-cards', loadChildren: () => import('./app/features/credit-card/credit-card.routes') },
          { path: 'cc-transactions', loadChildren: () => import('./app/features/cc-transaction/cc-transaction.routes') },
          { path: 'members', loadChildren: () => import('./app/features/member/member.routes') },
          { path: 'reconciliation', loadChildren: () => import('./app/features/reconciliation/reconciliation.routes') },
          { path: 'audit-trail', loadChildren: () => import('./app/features/audit-trail/audit-trail.routes') },
          { path: 'report-generation', loadChildren: () => import('./app/features/report-generation/report-generation.routes') },
          { path: 'profile', loadComponent: () => import('./app/pages/profile/profile.component').then(m => m.ProfileComponent) },

        ]
    },
    { path: 'notfound', component: Notfound },
    { path: '**', redirectTo: '/notfound' }
];
